import { actionTypes } from "./leaveApprovalActionTypes";

export const INITIAL_STATE = {
    approvals: [],
    pendingApprovals: [],
    approvalHistory: [],
    approvalStats: {},
    leaveRequest: [],
    loading: false,
    loadingMore: false,
    error: null,
    pendingCount: 0,
    pagination: {
        currentPage: 1,
        pageSize: 12,
        totalPages: 0,
        totalItems: 0,
        hasMore: false,
    },
    // Self-requested leaves state
    selfLeavesStats: {},
    selfLeaves: [],
    selfLeavesLoading: false,
    selfLeavesLoadingMore: false,
    selfLeavesPagination: {
        currentPage: 1,
        pageSize: 10,
        totalPages: 0,
        totalItems: 0,
        hasMore: false,
    },
};

export default function leaveApprovalReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionTypes.SET_LEAVE_APPROVALS:
            return {
                ...state,
                approvals: action.payload,
                error: null,
            };

        case actionTypes.SET_PENDING_APPROVALS:
            return {
                ...state,
                pendingApprovals: action.payload,
                pendingCount: action.payload.length,
                error: null,
            };

        case actionTypes.SET_APPROVAL_HISTORY:
            return {
                ...state,
                approvalHistory: action.payload,
                error: null,
            };

        case actionTypes.SET_APPROVAL_STATS:
            return {
                ...state,
                approvalStats: action.payload,
                error: null,
                loading: false,
            };

        case actionTypes.SET_LEAVE_REQUEST_CARDS:
            return {
                ...state,
                leaveRequest: action.payload.data,
                pagination: action.payload.pagination || state.pagination,
                error: null,
                loading: false,
            };

        case actionTypes.APPEND_LEAVE_REQUEST_CARDS:
            return {
                ...state,
                leaveRequest: [...state.leaveRequest, ...action.payload.data],
                pagination: action.payload.pagination || state.pagination,
                error: null,
                loadingMore: false,
            };

        case actionTypes.SET_PAGINATION_INFO:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload,
                },
            };

        case actionTypes.SET_LOADING_MORE:
            return {
                ...state,
                loadingMore: action.payload,
            };

        case actionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case actionTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        case actionTypes.CLEAR_APPROVALS:
            return {
                ...state,
                approvals: [],
                pendingApprovals: [],
                approvalHistory: [],
                pendingCount: 0,
                error: null,
            };

        case actionTypes.UPDATE_APPROVAL_STATUS:
            const updatedApprovals = state.approvals.map((approval) =>
                approval.id === action.payload.approvalId
                    ? { ...approval, approvalStatus: action.payload.status }
                    : approval
            );

            const updatedPendingApprovals = state.pendingApprovals.filter(
                (approval) => approval.id !== action.payload.approvalId
            );

            return {
                ...state,
                approvals: updatedApprovals,
                pendingApprovals: updatedPendingApprovals,
                pendingCount: updatedPendingApprovals.length,
            };

        case actionTypes.ADD_APPROVAL:
            return {
                ...state,
                approvals: [...state.approvals, action.payload],
                pendingApprovals: [...state.pendingApprovals, action.payload],
                pendingCount: state.pendingCount + 1,
            };

        case actionTypes.REMOVE_APPROVAL:
            const filteredApprovals = state.approvals.filter(
                (approval) => approval.id !== action.payload
            );
            const filteredPendingApprovals = state.pendingApprovals.filter(
                (approval) => approval.id !== action.payload
            );

            return {
                ...state,
                approvals: filteredApprovals,
                pendingApprovals: filteredPendingApprovals,
                pendingCount: filteredPendingApprovals.length,
            };

        // Self-requested leaves reducers
        case actionTypes.SET_SELF_LEAVES_STATS:
            return {
                ...state,
                selfLeavesStats: action.payload,
                error: null,
            };

        case actionTypes.SET_SELF_LEAVES:
            return {
                ...state,
                selfLeaves: action.payload.data || [],
                selfLeavesPagination: action.payload.pagination || state.selfLeavesPagination,
                error: null,
                selfLeavesLoading: false,
            };

        case actionTypes.APPEND_SELF_LEAVES:
            return {
                ...state,
                selfLeaves: [...state.selfLeaves, ...(action.payload.data || [])],
                selfLeavesPagination: action.payload.pagination || state.selfLeavesPagination,
                error: null,
                selfLeavesLoadingMore: false,
            };

        case actionTypes.SET_SELF_LEAVES_LOADING:
            return {
                ...state,
                selfLeavesLoading: action.payload,
            };

        case actionTypes.SET_SELF_LEAVES_LOADING_MORE:
            return {
                ...state,
                selfLeavesLoadingMore: action.payload,
            };

        default:
            return state;
    }
} 